module.exports = __webpack_public_path__ + "static/media/hat-wizard.01193b77.svg";